'use client'

// libraries
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import RoundedBox from '/react4xp/components/RoundedBox'
import Form from '/react4xp/components/Form/Form'
import Select from '/react4xp/components/Form/Select'

// svg
import { ArrowRight } from '/react4xp/components/Icons/Ux'

// css
import './index.scss'

// types
export interface CourseSearchProps {
    className?: string
    isAnimated?: boolean
    level?: {
        label?: string
        name?: string
        placeholder?: string
        options?: {
            label?: string
            value?: string
            disabled?: boolean
        }[]
    }
    areaOfInterest?: {
        label?: string
        name?: string
        placeholder?: string
        options?: {
            label?: string
            value?: string
            disabled?: boolean
        }[]
    }
    cta?: string
    endpoint?: string
}

export default function CourseSearch({
    className,
    isAnimated,
    level,
    areaOfInterest,
    cta,
    endpoint
}: CourseSearchProps) {

    const handleSubmit = (data: any) => {
        // Ao submeter, redireciona para a action com os campos do formulário como query params
        if (typeof window !== 'undefined' && data) {
            let url = `${endpoint}?`;
            Object.entries(data).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== '') {
                    url += `${key}=${decodeURIComponent(value as string)}&`;
                }
            });
            window.location.href = url;
        }
    }

    return (
        <Section className={clsx('course-search-component', className)}>
            {
                ((level?.options && (level?.options?.length > 0)) || (areaOfInterest?.options && (areaOfInterest?.options?.length > 0))) && (
                    <div
                        className='container'
                        data-stagger-up={isAnimated ? 'true' : 'false'}
                    >
                        <RoundedBox bgColor='green'>
                            <Form
                                onSubmit={handleSubmit}
                                className='course-search-component__flex'
                            >

                                {level && level?.options && (level?.options?.length > 0) && (
                                    <div className='course-search-component__item'>

                                        <label
                                            htmlFor='course-search-level'
                                            className='course-search-component__label body'
                                        >
                                            {level.label}
                                        </label>

                                        <Select
                                            options={level.options}
                                            size='medium'
                                            id='course-search-level'
                                            name={level.name || 'course-search-level'}
                                            selected={level.placeholder}
                                        />

                                    </div>
                                )}

                                {areaOfInterest && areaOfInterest?.options && (areaOfInterest?.options?.length > 0) && (
                                    <div className='course-search-component__item'>

                                        <label
                                            htmlFor='course-search-area-of-interest'
                                            className='course-search-component__label body'
                                        >
                                            {areaOfInterest.label}
                                        </label>

                                        <Select
                                            options={areaOfInterest.options}
                                            size='medium'
                                            id='course-search-area-of-interest'
                                            name={areaOfInterest.name || 'course-search-area-of-interest'}
                                            selected={areaOfInterest.placeholder}
                                        />

                                    </div>
                                )}
                                
                                <button
                                    type='submit'
                                    className='button-black'
                                >
                                    {cta} <ArrowRight />
                                </button>

                            </Form>
                        </RoundedBox>
                    </div>
                )
            }
        </Section>
    )
}